import { render, staticRenderFns } from "./videoVKYC.vue?vue&type=template&id=a65c7272"
import script from "./videoVKYC.vue?vue&type=script&lang=js"
export * from "./videoVKYC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports